import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { getCompanyData } from '@/assets/libs/requests'
import { waitForOnline } from '@libs/waitForOnline'
import NotFound from '@/views/NotFound.vue'
import Home from '../views/Home.vue'
import Infoboard from '../views/Infoboard.vue'
import PincodePage from '../views/PincodePage.vue'

const noAuth: string[] = ['Pincode', 'Home', 'NotFound']

const routes: Array<RouteRecordRaw> = [
	{
		component: PincodePage,
		name: 'Pincode',
		path: '/',
	},
	{
		component: Home,
		name: 'Home',
		path: '/test',
	},
	{
		component: Infoboard,
		name: 'Infoboard',
		path: '/infoboard',
	},
	{
		component: NotFound,
		name: 'NotFound',
		path: '/:pathMatch(.*)*',
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
})

router.beforeEach(async(to, _from, next) => {
	if (!to.name) {
		next({ name: 'Pincode' })
		return
	}

	if (noAuth.includes(to.name as string)) {
		next()
		return
	}

	await waitForOnline()
	const authTest = await getCompanyData()

	if (authTest.success) {
		next()
	} else {
		next({ name: 'Pincode' })
	}
})

export default router
